// extracted by mini-css-extract-plugin
export var logo = "_hl-2";
export var logoWrapper = "_hl-1";
export var strip = "_hl-0";